import { View } from 'react-native';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';
import { useRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { XResetClientIntakeDataFooterButton } from '@savvy/deprecated-shared/internal/x-components/x-reset-client-intake-data-footer-button';
import { XLink } from '@savvy/deprecated-shared/x-components/x-link';
import { XMuiThemeProvider } from '@savvy/deprecated-shared/x-components/x-mui-theme-provider';
import { toast } from '@savvy/deprecated-shared/x-components/x-toast';
import { XTypography } from '@savvy/deprecated-shared/x-components/x-typography';

function XSavvyFooterInner() {
  const { logout, isAuthenticated, user } = useAuth();
  const router = useRouter();
  const isSmallScreen = useIsSmallScreen();

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      router.push('/login');
    } catch (err) {
      console.error(err);
      toast.error('Unable to logout.');
    }
  };

  return (
    <View
      style={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {isAuthenticated && (
        <>
          <View
            style={{
              paddingHorizontal: 2,
              paddingBottom: 3,
            }}
          >
            <XLink
              href="#"
              onClick={() => {
                void handleLogout();
              }}
              underline="none"
            >
              <XTypography variant="caption" color="textSecondary">
                Logout
              </XTypography>
            </XLink>
          </View>
          <View style={{ paddingHorizontal: 2 }}>
            <XTypography variant="caption" color="textSecondary">
              •
            </XTypography>
          </View>
        </>
      )}
      {/* Only shown internally */}
      {!isSmallScreen && <XResetClientIntakeDataFooterButton user={user} />}

      <View
        style={{
          paddingHorizontal: 2,
        }}
      >
        <XLink
          color="textSecondary"
          target="_blank"
          underline="none"
          href="https://www.savvywealth.com/"
          variant="caption"
        >
          Savvy Wealth Inc.
        </XLink>
      </View>
    </View>
  );
}

export function XSavvyFooter() {
  return (
    <XMuiThemeProvider>
      <XSavvyFooterInner />
    </XMuiThemeProvider>
  );
}
